import { BaseEntity } from "yt-ng-framework";

export class Opstina extends BaseEntity{
    constructor(){
        super();
    };

    Naziv:string = null;
    OkrugID:number = null;

    Deserialize(input:any){
        this.ID = input.ID;
        this.Naziv=input.Naziv;
        this.OkrugID=input.OkrugID;
        return this;
    }

    Serialize(input:Opstina){
        return input;
    }

}